export const CaretSortDown = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24 24L16 32L8 24H24Z" fill="currentColor"/>
</svg>`;
